export const SUCCESS_STATUS_200 = 200;
export const ERROR_STATUS_400 = 400;
export const ERROR_STATUS_404 = 404;
export const ERROR_STATUS_500 = 500;
export const ERROR_MESSAGE_404 = "Not Found";
export const ERROR_MESSAGE_500 = "Internal Server Error";
